export const getTagsList = (tags: any[]) =>
  tags.map((tag) => {
    if (tag.isCustom) {
      return tag.name.replace('Add', '').replaceAll('"', '').trim();
    } else {
      return tag.id;
    }
  });
